import React from 'react';
import { Briefcase } from 'lucide-react';
import { iconRegistry } from './registry';

export interface SuiteIconProps {
  name?: string;
  className?: string;
  size?: number | string;
}

export const SuiteIcon: React.FC<SuiteIconProps> = ({
  name,
  className = 'h-4 w-4',
  size,
}) => {
  if (!name) {
    return <Briefcase className={className} size={size} />;
  }

  const IconComponent = iconRegistry[name] || Briefcase;
  return <IconComponent className={className} size={size} />;
};
